/**
 * HomeProducts functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class HomeProducts {
  /**
   * Constructs a new HomeProducts instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.homeProduct = this.element.querySelector('ul.products .product')
    this.homeProductsMediaQuery = window.matchMedia("(max-width: 1024px)")

    this.productHeight = this.homeProduct.clientHeight

    if (this.homeProductsMediaQuery.matches) {
      this.element.style.marginTop = 'calc(-' + this.productHeight + 'px - 2em)'
    }

  }
}



// WEBPACK FOOTER //
// ./components/section/home-products/index.js